export default {
    'PENDING': 'PENDING',
    'SUCCESS': 'SUCCESS',
    'ERROR': 'ERROR'
};